import React, { createContext, useState, useContext, useCallback } from 'react';

const BuilderContext = createContext();

export const useBuilder = () => {
  return useContext(BuilderContext);
};

export const BuilderProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Page siteSubs state for live updates
  const [liveSiteSubs, setLiveSiteSubs] = useState(null);

  // Site state for live updates (HeaderType01 등 GlobalHeader 컴포넌트용)
  const [liveSite, setLiveSite] = useState(null);

  // 컴포넌트 선택 핸들러
  const selectComponent = useCallback((component) => {
    setSelectedComponent(component);
  }, []);

  // 선택 해제
  const deselectComponent = useCallback(() => {
    setSelectedComponent(null);
  }, []);

  // 편집 모드 토글
  const toggleEditMode = useCallback(() => {
    setIsEditMode((prev) => {
      if (prev) {
        deselectComponent();
      }
      return !prev;
    });
  }, [deselectComponent]);

  // 사이드바 토글
  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  // 사이드바 열기
  const openSidebar = useCallback(() => {
    setIsSidebarOpen(true);
  }, []);

  // 사이드바 닫기
  const closeSidebar = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  // siteSubs 업데이트 (실시간 미리보기용)
  const updateLiveSiteSubs = useCallback((newSiteSubs) => {
    setLiveSiteSubs(newSiteSubs);
  }, []);

  // 단일 siteSub 업데이트
  const updateSingleSiteSub = useCallback((siteSubId, newObjects) => {
    setLiveSiteSubs((prev) => {
      if (!prev) return prev;
      return prev.map((sub) =>
        sub.id === siteSubId ? { ...sub, objects: newObjects } : sub
      );
    });
  }, []);

  // Site 초기화 (페이지 로드 시)
  const initLiveSite = useCallback((site) => {
    setLiveSite(site);
  }, []);

  // Site 업데이트 (HeaderType01 실시간 미리보기용)
  const updateLiveSite = useCallback((updates) => {
    setLiveSite((prev) => {
      if (!prev) return prev;
      return { ...prev, ...updates };
    });
  }, []);

  const value = {
    isEditMode,
    toggleEditMode,
    selectedComponent,
    selectComponent,
    deselectComponent,
    isSidebarOpen,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    liveSiteSubs,
    updateLiveSiteSubs,
    updateSingleSiteSub,
    // Site 실시간 업데이트 (HeaderType01용)
    liveSite,
    initLiveSite,
    updateLiveSite,
  };

  return (
    <BuilderContext.Provider value={value}>
      {children}
    </BuilderContext.Provider>
  );
};
